module.exports = __webpack_public_path__ + "static/media/infos-icon.b9062cd9.svg";